import { Outlet, createFileRoute } from "@tanstack/react-router";
import { VideoRecorder } from "@untitled-ui/icons-react";

import Layout from "@/layouts/Layout";
import { useRouterLayout } from "@/layouts/useRouterLayout";
import type { ChildRouteContext } from "@/root";
import { fetchMeQueryOptions } from "@/user/services";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/_meet")({
  beforeLoad: async ({ context }) => {
    redirectIfModuleDisabled("meet", context.tenant.modules);

    const user = await context.queryClient.ensureQueryData(
      fetchMeQueryOptions(),
    );

    const isGuest = !user;

    return {
      title: () => context.t("Meeting Room", { ns: "meet.user" }),
      user: user ?? undefined,
      hideMenu: isGuest,
      hideHeader: isGuest,
      hideWidgets: isGuest,
      crumb: [
        { Icon: VideoRecorder },
        {
          label: context.t("Meeting Room", { ns: "meet.user" }),
          link: { to: "/meet/sessions" },
        },
      ],
    } satisfies ChildRouteContext;
  },
  component: Component,
});

function Component() {
  const { hideMenu, hideHeader, hideCrumb, hideWidgets, isCompact } =
    useRouterLayout();
  return (
    <Layout
      hideMenu={hideMenu}
      hideHeader={hideHeader}
      hideCrumb={hideCrumb}
      hideWidgets={hideWidgets}
      isCompact={isCompact}
    >
      <Outlet />
    </Layout>
  );
}
